import dateTimeHelper from "../Helpers/datetimeHelper";
import moneyHelper from "../Helpers/moneyHelper";

export default class ReconcileParamsItem
{
	constructor(item) 
	{
		this.ExportPaymentId=item.ExportPaymentId;
        this.EvaluatorId=item.EvaluatorId;;
        this.ExportId=item.ExportId;
        this.CurrencyId=item.CurrencyId;
        this.PaymentMethod=item.PaymentMethod;
        this.PaymentDate=new Date(item.PaymentDate);
        this.TransactionMethod=item.TransactionMethod; 
        this.TransactionDate=item.TransactionDate?new Date(item.TransactionDate):new Date();
        this.TransactionFee=0;
        this.AdministrativeFee=0;
        this.TransactionReferenceNumber="";
        this.Notes="";
        this.Reason="";
		this.Due=moneyHelper.toMoneyFormat(item.Due,item.CurrencyCode);
		this.ShopperName=item.EvFirstName+" "+item.EvLastName;
		this.ExportDate=dateTimeHelper.toYYYYsMMsDD(item.ExportDate);
	}
}
